module.exports = __webpack_public_path__ + "img/Athene_logo_sw.svg.ff502bf5.png";